import https from './http.js';

let apiFun = {};

/* 获取列表 */
//查询列表，详情就是get
/* /api/getlist是请求接口地址，有http.js里面的Ip加上，如：http:192.168.0.1:9090//api/getlist  */
apiFun.get = function (url, params) {
  return https.get(url, params);
};

apiFun.post = function (url, params) {
  return https.post(url, params);
};
apiFun.login = function (params) {
  return https.post('/api/login_pc', params);
  // return https.post('/api/login', params)
};
apiFun.register = function (params) {
  return https.post('/api/register', params);
};
//暴露出这个对象
export default apiFun;
